import React from 'react'
import { Box, SearchInput, Text } from '@workwhile/ui'
import { useJurisdictionsContextValue } from '../context/JurisdictionsProvider'

export const JurisdictionsSearch = () => {
  const {
    state: { searchInput, suggestedMatch },
    actions: { setSearchInput },
  } = useJurisdictionsContextValue()

  return (
    <Box mb={3} maxWidth={['100%', '100%', '100%', '50%']}>
      <SearchInput
        keyword={searchInput}
        setKeyword={setSearchInput}
        placeholder="Search by name or ID"
        block
        clearable={false}
      />
      <Text
        color="lightText"
        mt={2}
        style={{
          visibility: suggestedMatch ? 'visible' : 'hidden',
        }}
      >
        Did you mean "{suggestedMatch}"?
      </Text>
    </Box>
  )
}
